import * as React from 'react';
import { Sticky } from '../Sticky';
import * as styles from './CallbackButtonWrapper.css';

export const CallbackButtonWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Sticky className={styles['container']} dataName="CallbackButtonWrapper">
      <div className={styles['inner']}>{children}</div>
    </Sticky>
  );
};
